import apiClient from './client';

export interface SearchResult {
  id: string;
  type: string;
  module: string;
  label: string;
  title: string;
  subtitle: string;
  route: string | null;
}

export interface SearchGroup {
  module: string;
  items: SearchResult[];
}

export interface SearchResponse {
  groups: SearchGroup[];
  total: number;
}

export const searchApi = {
  global: (q: string) =>
    apiClient
      .get<{ code: number; data: SearchResponse }>('/search', { params: { q } })
      .then((r) => r.data.data)
};
